import get from 'lodash/get';

import { getRequestFunction } from 'root/requestFunction';

class AddCode implements MerchantosAddCode {
  runJavascriptCode = (javascriptCode: QueueRequest[]) => {
    if (javascriptCode?.length) {
      javascriptCode.forEach((code) => {
        const request = getRequestFunction(code);
        if (typeof request === 'function') {
          request();
        }
      });
    }
  };

  blurIfGriffin = () => {
    if (window.isGriffin()) {
      // @ts-ignore
      document.activeElement?.blur();
    }
  };

  signaturePromptIfGriffin = (payments: any[]) => {
    if (window.isGriffin()) {
      window.merchantos.register.credit_card.signaturePrompt(payments);
    }
  };

  paymentsOnChange = (defaultAccountPayment: any) => {
    setTimeout(() => {
      const input = $('#charge_account_payment')[0] as HTMLInputElement;
      if (input) {
        input.value = `${defaultAccountPayment}`;
        window.merchantos.register.payments.onChange(input);
      }
    }, 50);
  };

  addClass: MerchantosAddCode['addClass'] = (selector, className) => {
    $(selector).removeClass(className);
  };

  removeClass: MerchantosAddCode['removeClass'] = (selector, className) => {
    $(selector).removeClass(className);
  };

  disableGetsOption = () => {
    $('#customer_gets_option_discount_on_single_item').prop('disabled', true);
  };

  addOnChangeDiscountRule = () => {
    window.onChangeDiscountRuleAddItemsCallback = function () {
      window.merchantos.discountRules.makeAddAllItemsButtonDirty();
    };
  };

  keyboardSubscribe: MerchantosAddCode['keyboardSubscribe'] = (
    shortcut,
    method,
    param1,
    param2
  ) => {
    window.merchantos.keyboard.subscribe(shortcut, function () {
      get(window, `${method}`)(param1, param2);
    });
  };

  focusVendorNum = () => {
    $(document)
      .off('.vendorNum')
      .on(
        'focus.vendorNum',
        'input[id^="item_listings_vendor_nums_view_vendor_num"]',
        function handleVendorNumFocus() {
          const jThis = $<HTMLInputElement>(this);
          jThis.attr('previousvalue', jThis.val() as string);
        }
      );
  };

  replaceVendorCurrencySymbol = () => {
    window.merchantos.vendors.getCurrencyCodeFromUI().then((currencyCodes) => {
      window.merchantos.multiCurrency.fieldBase.replaceCurrencySymbol({
        currencyCodes,
        targetSelector: 'input[id*="listing_vendor_cost"]',
      });

      window.merchantos.multiCurrency.fieldBase.replaceCurrencySymbol({
        currencyCodes,
        targetSelector: 'input[id*="item_listings_vendor_nums_view_vendor_cost"]',
      });
    });
  };

  replaceShipVendorCostsCurrencySymbol: MerchantosAddCode['replaceShipVendorCostsCurrencySymbol'] =
    (currencySymbol) => {
      window.merchantos.multiCurrency.fieldBase.replaceCurrencySymbol({
        currencySymbols: [currencySymbol],
        targetSelector: '#view_ship_vendor_cost, #view_other_vendor_cost',
      });
    };

  changeVendorCallbackConfirm = () => {
    window.onChangeVendorCallback = function () {
      if (
        // eslint-disable-next-line no-alert
        window.confirm(
          'This will permanently remove any changes you made to the calculated unit cost.'
        )
      ) {
        window.setTimeout(() => {
          $('#saveButton').trigger('click');
        }, 0);
      }
    };
  };

  changeVendorCallback: MerchantosAddCode['changeVendorCallback'] = (itemId) => {
    window.onChangeVendorCallback = function (value: number) {
      window.merchantos.vendors.updateProductDetailsTab({
        itemID: itemId,
        vendorID: value,
      });
    };
  };

  appendCurrencyCodesAndReplaceCurrencySymbol: MerchantosAddCode['appendCurrencyCodesAndReplaceCurrencySymbol'] =
    (businessCurrencyCode, vendorCurrencyCode, vendorCurrencySymbol) => {
      window.merchantos.vendors.appendVendorCurrencyCode({
        currencyCode: businessCurrencyCode,
        targetSelector: '#view_default_cost',
      });

      window.merchantos.vendors.appendVendorCurrencyCode({
        currencyCode: vendorCurrencyCode,
        hasWhatIsThisLink: true,
        targetSelector: '#view_vendor_cost',
      });

      window.merchantos.multiCurrency.fieldBase.replaceCurrencySymbol({
        currencySymbols: [vendorCurrencySymbol],
        targetSelector: '#view_vendor_cost',
      });
    };

  changeAddVendorNumVendor = () => {
    window.onChangeAddVendorNumVendorCallback = function (value) {
      window.merchantos.vendors.updateProductVendorIDsTab({
        vendorID: value,
      });
    };
  };

  replaceVendorCostCurrencySymbol: MerchantosAddCode['replaceVendorCostCurrencySymbol'] = (
    currencySymbol
  ) => {
    window.merchantos.multiCurrency.fieldBase.replaceCurrencySymbol({
      currencySymbols: [currencySymbol],
      targetSelector: '#view_add_vendor_cost',
    });
  };
}

window.merchantos.addCode = new AddCode();

$(() => {
  window.merchantos.addCode.runJavascriptCode(window.javascript_code);
});
